import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from '../ui/FadeIn';
import { CTAButton } from '../ui/CTAButton';
import { CheckCircle2, Gift, Zap, FileSearch } from 'lucide-react';
export function OfferSection() {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const basePrice = 8;
  const bump1Price = 6.5;
  const bump2Price = 6.5;
  const total = basePrice + (bump1 ? bump1Price : 0) + (bump2 ? bump2Price : 0);
  const handlePurchase = () => {
    let cartUrl: string;
    if (bump1 && bump2) {
      cartUrl = 'https://tres33group.com/cart/43118416855101:1';
    } else if (bump1) {
      cartUrl = 'https://tres33group.com/cart/43118414331965:1';
    } else if (bump2) {
      cartUrl = 'https://tres33group.com/cart/43118414364733:1';
    } else {
      cartUrl = 'https://www.tres33group.com/cart/43089344135229:1';
    }
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Protocolo de Rescate Renal',
        content_type: 'product',
        value: total,
        currency: 'USD'
      });
    }
    window.open(cartUrl, '_blank');
  };
  return <section id="offer-section" className="py-24 px-6 bg-white" data-id="element-272">
      <div className="max-w-5xl mx-auto" data-id="element-273">
        <FadeIn data-id="element-274">
          <div className="bg-cream rounded-3xl p-8 md:p-12 shadow-2xl border border-amber/20 overflow-hidden relative" data-id="element-275">
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-276">
              <div data-id="element-277">
                <h2 className="text-3xl md:text-4xl font-bold text-forest mb-6" data-id="element-278">
                  Tus riñones son tu filtro de vida.
                </h2>
                <p className="text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-279">
                  Si ellos se detienen, tu vida se detiene. Este no es un gasto,
                  es una inversión en tu autonomía.
                </p>

                <div className="bg-white p-6 rounded-2xl shadow-inner mb-6 border border-gray-100" data-id="element-280">
                  <p className="text-lg text-gray-600 mb-4" data-id="element-281">
                    Obtén el Protocolo de Rescate para Tus Riñones con todos los
                    anexos incluidos hoy mismo.
                  </p>

                  <div className="space-y-3 mb-6" data-id="element-282">
                    <div className="flex items-start gap-3" data-id="element-283">
                      <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-284" />
                      <p className="text-gray-700" data-id="element-285">
                        <span className="font-semibold" data-id="element-286">
                          Protocolo Maestro de 14 Días para tus Riñones
                        </span>{' '}
                        (Valor: $27)
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-287">
                      <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-288" />
                      <p className="text-gray-700" data-id="element-289">
                        <span className="font-semibold" data-id="element-290">
                          Recetario 'Sabor Renal' con 50 Recetas
                        </span>{' '}
                        (Valor: $37)
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-291">
                      <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-292" />
                      <p className="text-gray-700" data-id="element-293">
                        <span className="font-semibold" data-id="element-294">
                          Guía de Hidratación Osmótica de Precisión
                        </span>{' '}
                        (Valor: $15)
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-295">
                      <Gift className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-296" />
                      <p className="text-gray-700" data-id="element-297">
                        <span className="font-semibold text-gray-900" data-id="element-298">
                          BONO 1: Kit de Comidas Seguras en 5 Minutos
                        </span>{' '}
                        (Valor: $47)
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-299">
                      <Gift className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-300" />
                      <p className="text-gray-700" data-id="element-301">
                        <span className="font-semibold text-gray-900" data-id="element-302">
                          BONO 2: Guía Express para Entender tu Rutina Renal
                        </span>{' '}
                        (Valor: $47)
                      </p>
                    </div>
                  </div>

                  <div className="border-t border-gray-100 pt-4 text-center" data-id="element-303">
                    <p className="text-gray-500 line-through mb-1" data-id="element-304">
                      Valor Total: $173.00 | Hoy por solo: $8.00
                    </p>
                    <p className="text-xl font-bold text-forest" data-id="element-305">
                      Hoy por solo:
                    </p>
                    <motion.p key={total} initial={{
                    scale: 1.1
                  }} animate={{
                    scale: 1
                  }} transition={{
                    duration: 0.3
                  }} className="text-6xl font-black text-amber mt-1" data-id="element-306">
                      ${total.toFixed(2)} USD
                    </motion.p>
                  </div>
                </div>

                {/* DYNAMIC TOTAL */}
                <AnimatePresence mode="wait" data-id="element-307">
                  {(bump1 || bump2) && <motion.div initial={{
                  opacity: 0,
                  height: 0
                }} animate={{
                  opacity: 1,
                  height: 'auto'
                }} exit={{
                  opacity: 0,
                  height: 0
                }} className="mb-4 overflow-hidden" data-id="element-308">
                      <div className="bg-forest/5 border border-forest/20 rounded-xl p-4 text-center" data-id="element-309">
                        <p className="text-sm text-gray-600 mb-1" data-id="element-310">
                          Tu total de hoy:
                        </p>
                        <div className="flex items-center justify-center gap-3 flex-wrap" data-id="element-311">
                          <span className="text-gray-500" data-id="element-312">Protocolo $8.00</span>
                          {bump1 && <span className="text-gray-500" data-id="element-313">
                              + Protocolo 48h $6.50
                            </span>}
                          {bump2 && <span className="text-gray-500" data-id="element-314">
                              + Intérprete Pro $6.50
                            </span>}
                        </div>
                        <motion.p key={total} initial={{
                      scale: 1.15
                    }} animate={{
                      scale: 1
                    }} className="text-3xl font-black text-forest mt-2" data-id="element-315">
                          = ${total.toFixed(2)} USD
                        </motion.p>
                      </div>
                    </motion.div>}
                </AnimatePresence>

                <CTAButton className="w-full text-lg md:text-xl py-6" onClick={handlePurchase} data-id="element-316">
                  {bump1 || bump2 ? `¡QUIERO TODO POR SOLO $${total.toFixed(2)}!` : '¡SÍ, QUIERO MI CUPO Y MIS BONOS POR SOLAMENTE $8!'}
                  <span className="block text-sm font-normal mt-1 opacity-90" data-id="element-317">
                    (Acceso inmediato al PDF y todos los materiales)
                  </span>
                </CTAButton>

                {/* ORDER BUMPS */}
                <div className="mt-6 space-y-4" data-id="element-318">
                  {/* ORDER BUMP 1 */}
                  <motion.button type="button" onClick={() => setBump1(!bump1)} animate={!bump1 ? {
                  boxShadow: ['0 0 0 0 rgba(212, 160, 23, 0)', '0 0 0 6px rgba(212, 160, 23, 0.15)', '0 0 0 0 rgba(212, 160, 23, 0)']
                } : {}} transition={!bump1 ? {
                  duration: 2.5,
                  repeat: Infinity,
                  ease: 'easeInOut'
                } : {}} className={`w-full text-left rounded-xl border-2 border-dashed transition-all duration-200 overflow-hidden ${bump1 ? 'border-amber bg-amber/5 shadow-md' : 'border-gray-300 bg-white hover:border-amber/50'}`} data-id="element-319">
                    <div className="bg-amber/10 px-4 py-2 flex items-center gap-2" data-id="element-320">
                      <Zap className="w-4 h-4 text-amber" data-id="element-321" />
                      <span className="text-sm font-bold text-amber uppercase tracking-wide" data-id="element-322">
                        Oferta Especial — Agrega a tu pedido
                      </span>
                      <div className={`ml-auto w-5 h-5 rounded border-2 shrink-0 flex items-center justify-center transition-colors ${bump1 ? 'bg-amber border-amber' : 'border-gray-300'}`} data-id="element-323">
                        {bump1 && <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-324">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-325" />
                          </svg>}
                      </div>
                    </div>
                    <div className="p-4" data-id="element-326">
                      <img src="https://cdn.magicpatterns.com/uploads/mpKBnwsW11Fxz1PmSKvn3k/order_1.png" alt="Protocolo 48H Desinflamación Renal Express" className="w-full h-auto max-h-48 object-contain rounded-lg mb-4" data-id="element-327" />
                      <h4 className="font-bold text-gray-900 text-base mb-2" data-id="element-328">
                        Desinflámate Hoy (Protocolo 48h) —{' '}
                        <span className="text-amber" data-id="element-329">$6.50</span>
                      </h4>
                      <p className="text-sm text-gray-600 leading-relaxed" data-id="element-330">
                        Agrega el Kit Express y recibe la hoja de ruta para
                        eliminar la retención de líquidos y sentir alivio
                        inmediato en pies y manos. Limpia tus riñones y
                        desínflate antes de iniciar el plan maestro. La vía
                        rápida para sentirte ligero desde este fin de semana.
                      </p>
                    </div>
                  </motion.button>

                  {/* ORDER BUMP 2 */}
                  <motion.button type="button" onClick={() => setBump2(!bump2)} animate={!bump2 ? {
                  boxShadow: ['0 0 0 0 rgba(212, 160, 23, 0)', '0 0 0 6px rgba(212, 160, 23, 0.15)', '0 0 0 0 rgba(212, 160, 23, 0)']
                } : {}} transition={!bump2 ? {
                  duration: 2.5,
                  repeat: Infinity,
                  ease: 'easeInOut',
                  delay: 1.25
                } : {}} className={`w-full text-left rounded-xl border-2 border-dashed transition-all duration-200 overflow-hidden ${bump2 ? 'border-amber bg-amber/5 shadow-md' : 'border-gray-300 bg-white hover:border-amber/50'}`} data-id="element-331">
                    <div className="bg-amber/10 px-4 py-2 flex items-center gap-2" data-id="element-332">
                      <FileSearch className="w-4 h-4 text-amber" data-id="element-333" />
                      <span className="text-sm font-bold text-amber uppercase tracking-wide" data-id="element-334">
                        Oferta Especial — Agrega a tu pedido
                      </span>
                      <div className={`ml-auto w-5 h-5 rounded border-2 shrink-0 flex items-center justify-center transition-colors ${bump2 ? 'bg-amber border-amber' : 'border-gray-300'}`} data-id="element-335">
                        {bump2 && <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-336">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-337" />
                          </svg>}
                      </div>
                    </div>
                    <div className="p-4" data-id="element-338">
                      <img src="https://cdn.magicpatterns.com/uploads/oKFi1gyFfHqwAGEiniiBde/order_2.png" alt="El Intérprete Renal Pro" className="w-full h-auto max-h-48 object-contain rounded-lg mb-4" data-id="element-339" />
                      <h4 className="font-bold text-gray-900 text-base mb-2" data-id="element-340">
                        Entiende tus Análisis (Intérprete Pro) —{' '}
                        <span className="text-amber" data-id="element-341">$6.50</span>
                      </h4>
                      <p className="text-sm text-gray-600 leading-relaxed" data-id="element-342">
                        Agrega el Intérprete Pro y recibe el manual para
                        descifrar la Creatinina, TFG y Urea en lenguaje simple.
                        Aprende a monitorear tu salud en casa y toma el control
                        de tus resultados médicos sin miedo ni confusión.
                      </p>
                    </div>
                  </motion.button>
                </div>
              </div>

              <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-white" data-id="element-343">
                <img src="https://cdn.magicpatterns.com/uploads/jJtAf6N5nAkiVAVHSkyMLJ/Rescate_renal_y_bienestar_personal.png" alt="Hombre relajado bebiendo agua con limón y leyendo el protocolo" className="w-full h-auto object-cover" data-id="element-344" />
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}